import { render, staticRenderFns } from "./EntityFilterCampaignlogs.vue?vue&type=template&id=61e0448b"
import script from "./EntityFilterCampaignlogs.vue?vue&type=script&lang=js"
export * from "./EntityFilterCampaignlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports